import React from 'react';
import * as cls from './how-it-works.module.css';
import { IMG_PATH } from '../../../../constants';
import { Section } from '../../../../ui/components/section';
import { Typography } from '../../../../ui/components/typography';

const items = [
  {
    title: 'Capture',
    text: (
      <>
        from a single measurement point (smart meter data, compatible dongle, or
        Voltaware sensor).
      </>
    ),
  },

  {
    title: 'Disaggregate',
    text: (
      <>
        AI maps the whole-home signal to <b>appliance-level usage and events</b>
        .
      </>
    ),
  },

  {
    title: 'Enrich & learn',
    text: (
      <>
        models update as new patterns appear and as users provide optional
        feedback.
      </>
    ),
  },

  {
    title: 'Deliver insights',
    text: (
      <>
        clear, intelligent energy insights such as bill breakdowns, targeted
        offers, and safety signals - available in the app or via APIs.
      </>
    ),
  },
];

export const HowItWorks = () => {
  return (
    <Section backgroundContrast classNameRoot={cls.section}>
      <Typography as="h1" tag="h2">
        How It Works (at a glance)
      </Typography>

      <div className={cls.wrapper}>
        <div>
          {items.map((item, index) => (
            <div key={index} className={cls.item}>
              <div className={cls.itemNumber}>
                <span>{index + 1}</span>
              </div>
              <div>
                <Typography tag="h3">{item.title}</Typography>
                <Typography>{item.text}</Typography>
              </div>
            </div>
          ))}
        </div>
        <img
          alt=""
          src={`${IMG_PATH}/our-technology/energy-intelligence/how-it-works.png`}
        />
        <img
          alt=""
          className={cls.imgMobile}
          src={`${IMG_PATH}/our-technology/energy-intelligence/how-it-works-mobile.png`}
        />
      </div>
    </Section>
  );
};
